(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["omar-cutting-instructions"] && !Shopify.designMode) return;
  try {
    function openCuttingRequest() {
  if (window.location.hash !== '#cutting-instructions') return;
  const panel = document.querySelector('[data-cutting-product]');
  if (!panel) return;
  panel.open = true;
  panel.scrollIntoView({block:'center'});
  panel.querySelector('textarea')?.focus({preventScroll:true});
}
document.addEventListener('DOMContentLoaded', openCuttingRequest);
window.addEventListener('hashchange', openCuttingRequest);
openCuttingRequest();
  } catch(e) { console.error(e); }
})();

})();
